import { CostsPerEmployee } from "./cost-per-employee";
import { CostsPerEmployeeDivisionArea } from "./cost-per-employee-division-area";



export class CostsPerEmployeeConfiguration {

    id: number = 0;
    costsPerEmployee: CostsPerEmployee = new CostsPerEmployee();
    description!: string;
    formula!: string;
    active: boolean = false;

    costsPerEmployeeDivisionAreaList: CostsPerEmployeeDivisionArea[] = [];
    
}